import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Flex,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '../../../../auth-context/auth.context';
import SavingsPlanApi from 'api/savingplan';
import { MetalTypesOptions } from 'config/constant';
import { Categories } from 'config/constant';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import TextAreaField from 'components/formComponents/textAreaField';

export default function AddSavingPlan(props) {
  const { user } = useAuth();
  const toast = useToast();
  const toastIdRef = React.useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const initialValues = {
    type: 'GOLD22KT',
    category: '',
    order: '',
    description: '',
    status: '',
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string().required('Type is required'),
    category: Yup.string().required('Category is required'),
    order: Yup.number()
      .required('Display order is required')
      .positive('Display order must be positive')
      .integer('Display order must be an integer'),
    description: Yup.string()
      .trim()
      .required('A short description is required'),
    status: Yup.boolean().required('Status is required'),
  });

  const AddCompany = async (values, actions) => {
    const { name, type, category, order, description, status } = values;
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    if (!type || !category || !order || status === '') {
      toastIdRef.current = toast({
        title: 'All fields are required',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      actions.setSubmitting(false);
    } else {
      try {
        let response = await SavingsPlanApi.Create({
          name,
          type,
          category,
          order,
          description,
          status,
        });
        response = response.data;
        if (response.status_code === 200) {
          toastIdRef.current = toast({
            title: 'Successfully Added',
            status: 'success',
            duration: 5000,
            isClosable: true,
            position: 'top',
          });
          onClose();
          props.func();
        } else {
          toastIdRef.current = toast({
            title: response?.message,
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top',
          });
        }
        actions.setSubmitting(false);
      } catch (err) {
        console.log(err);
        actions.setSubmitting(false);
      }
    }
  };

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        onClick={onOpen}
        disabled={props.disabled}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={AddCompany}>
              {({ isSubmitting }) => (
                <Form noValidate>
                  <Flex direction='column'>
                    <SelectField
                      name='category'
                      label='Category'
                      options={Categories.map((category) => ({
                        label: category,
                        value: category,
                      }))}
                      placeholder='Select Category'
                      required
                    />
                    <SelectField
                      name='type'
                      label='type'
                      options={MetalTypesOptions}
                      placeholder='Select Type'
                      required
                    />
                    <InputField
                      name='order'
                      label='Display Order'
                      type='number'
                      placeholder='Enter Display Order'
                      required
                    />
                    <TextAreaField
                      label='Short Description of the Plan'
                      name='description'
                      type='text'
                      placeholder='Upto 200 Characters'
                      required
                    />
                    <SelectField
                      name='status'
                      label='Status'
                      options={[
                        { label: 'Active', value: 'true' },
                        { label: 'Inactive', value: 'false' },
                      ]}
                      placeholder='Select Plan Status'
                      required
                    />
                  </Flex>
                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}>
                      Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
